import React from "react";
import SinglePolicyReport from "./report/SinglePolicyReport";
import SingleProcedureReport from "./report/SingleProcedureReport";

/**
 * PrintPolicyReport Component
 * Generates a printable report containing policies and procedures information
 * Displays policy details followed by procedure details in a structured format
 * @param {Object} props - Component props
 * @param {Array} props.proceduresDetails - Array of procedure data objects
 * @param {Array} props.policiesDetails - Array of policy data objects
 * @returns {JSX.Element} Policy report layout
 */
const PrintPolicyReport = ({ proceduresDetails, policiesDetails }) => {
  return (
    <>
      {/* Report Header */}
      <div className="flex items-center justify-between px-4">
        <p className="text-3xl font-medium">Policy Report</p>
      </div>
      
      {/* Report Content */}
      <div className="px-4 my-2">
        {/* Policies Section */}
        <p className="text-center font-medium text-2xl">Policies Information</p>
        <div className="my-4">
          {policiesDetails?.map((policyData, index) => (
            <SinglePolicyReport 
              key={policyData?.id || index} 
              data={policyData} 
            />
          ))}
        </div>
        
        {/* Section Divider */}
        <hr className="text-gray my-2" />
        
        {/* Procedures Section */}
        <p className="text-center font-medium text-2xl">
          Procedure Information
        </p>

        <div className="my-4">
          {proceduresDetails?.map((procedureData, index) => (
            <SingleProcedureReport 
              key={procedureData?.id || index} 
              data={procedureData} 
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default PrintPolicyReport;
